import React from 'react';

import useStyles from './styles';

import Tag from '../Tag';

interface Props {
    className?: string;
}

const NodeTag: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            <Tag label="Node" />
        </div>
    );
};

export default NodeTag;
